class SettingsService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getSettings() {
    return this.apiService.get('/api/v1/settings');
  }

  updateSettings(data) {
    return this.apiService.put('/api/v1/settings', data);
  }

  updatePdfPresets(data) {
    return this.apiService.patch('/api/v1/settings/pdf-templates', data);
  }

  updateCompanyLogo(data) {
    return this.apiService.patch('/api/v1/settings/company-logo', data);
  }

  updateImportDefaultEncoding(data) {
    return this.apiService.patch('/api/v1/settings/import-default-encoding', data);
  }
}

export default SettingsService;
